// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"704":"a4173acc","705":"481cdf45","723":"8e093df1","766":"77ff5835","938":"d5aa8246","981":"9f615193"}[chunkId] + ".chunk.css";
};